import styles from "./TopBarBodyEnd.module.scss"
import { TopBarBodyEndProps } from "./TopBarBodyEnd.types"

export default function TopBarBodyEnd(props: TopBarBodyEndProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
